/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-events',
    'window'
],
function(
    $,
    Mustache,
    pip,
    pipEvents,
    window
) {

    var template = '<div class="quantity quantity-section-wrapper u__clearfix">'
                 + '<label for="{{ containerId }}__input">Quantity</label>'
                 + '<div class="quantity-field-wrapper u__clearfix">'
                 + '<div class="quantity-btn decrement">-</div>'
                 + '<input id="{{ containerId }}__input" class="quantity-input" type="number" value="{{ quantity }}" min="0" max="9999" maxlength="4" inputmode="numeric" pattern="[0-9]*">'
                 + '<div class="quantity-btn increment">+</div>'
                 + '</div>'
                 + '</div>';

    var Quantity = function Quantity(containerId, minimumQuantity) {

        var _this = this;

        this.containerId = containerId;
        this.containerString = containerId.substr(1);
        this.nameSpace = '.quantityClick__' + this.containerString;
        this.selectors = {
            quantityBoxId: _this.containerId + '__input'
        };
        this.minimumQuantity = minimumQuantity;

        this.view = {
            update: function update() {
                $(_this.selectors.quantityBoxId, _this.containerId).val(pip.customer.quantity);
            },
            render: function render() {
                return Mustache.render(template, {containerId: _this.containerString, quantity: pip.customer.quantity});
            }
        };

        $(this.containerId).html(this.view.render());

        this.initListeners = function initListeners() {
            var _this = this;

            pipEvents.pipModel.pipModelQuantityUpdated.off(_this.containerString);
            pipEvents.pipModel.pipModelQuantityUpdated.on(_this.containerString, function() {
               _this.view.update()
                //NEEDED TO SUPPORT LEGACY MAML CODE
                $('#buybox_quantity_field').val(pip.customer.quantity);
            });

            $(window.document).off(_this.nameSpace);

            $(window.document).on('click' + _this.nameSpace, _this.containerId + ' .quantity-btn.increment', function(e) {
                e.preventDefault();
                _this.increment();
            });

            $(window.document).on('click' + _this.nameSpace, _this.containerId + ' .quantity-btn.decrement', function(e) {
                e.preventDefault();
                _this.decrement();
            });

            $(window.document).on('blur' + _this.nameSpace, _this.containerId + ' .quantity-input', function(){
                if(!this.value) {
                    this.value = 1;
                }
                var previousValue = this.value;
                pip.customer.quantity = _this.determineQuantityValue(this);
                if (pip.customer.quantity !== previousValue
                  && pip.features.minimumOrderQuantityEnabled
                  && pip.customer.quantity === pip.customer.minimumQuantity) {
                  pipEvents.quantity.minimumQuantityWarning.trigger();
                } else {
                  pipEvents.quantity.clearMinimumQuantityWarning.trigger();
                }
                pipEvents.pipModel.pipModelQuantityUpdated.trigger();
            });

            $(window.document).on('keyup' + _this.nameSpace, _this.containerId + ' .quantity-input', function(){
                this.value = this.value.replace(/[^0-9]/g, '');
                if(this.value) {
                  pip.customer.quantity = _this.determineQuantityValue(this, true);
                  pipEvents.pipModel.pipModelQuantityUpdated.trigger();
                  pipEvents.quantity.clearMinimumQuantityWarning.trigger();
                }

            });
        };

        this.initListeners();
    };

    Quantity.prototype.increment = function increment() {
        if (pip.customer.quantity < 9999) {
            pip.customer.quantity++;
            pipEvents.pipModel.pipModelQuantityUpdated.trigger();
            pipEvents.quantity.clearMinimumQuantityWarning.trigger();
        }
    };

    Quantity.prototype.decrement = function decrement() {
        if (this.minimumQuantity && pip.customer.quantity === this.minimumQuantity) {
          pipEvents.quantity.minimumQuantityWarning.trigger();
          return;
        }
        if (pip.customer.quantity > 1) {
            pip.customer.quantity--;
            pipEvents.pipModel.pipModelQuantityUpdated.trigger();
        }
    };

    Quantity.prototype.determineQuantityValue = function determineQuantityValue(el, isKeyup) {
      var elementValueAsString = el.value.toString();
      var truncatedValue;

      if(!isKeyup && elementValueAsString.length > 0 && pip.features.minimumOrderQuantityEnabled && this.minimumQuantity && parseInt(el.value) < this.minimumQuantity) {
        el.value = this.minimumQuantity;
        return parseInt(el.value);
      }

      if(elementValueAsString.length > 4) {
          truncatedValue = elementValueAsString.substr(0,4);
          el.value = truncatedValue;
          return parseInt(truncatedValue, 10);
      }

      return parseInt(el.value);
    };

    return {
        create: function create (containerId, minimumQuantity) {
            return new Quantity(containerId, minimumQuantity);
        }
    }
});

}.call(window));